<template>
	<div class="row d-flex justify-content-center">
		<div class="col-12 table-wrapper-list" v-if="list.length > 0">
			<table class="table">
				<thead>
					<tr>
						<td>Ügyfél</td>
						<td>Régió</td>
						<td>Becsült szállítás</td>
						<td>Termék</td>
						<td>Darabszám</td>
					</tr>
				</thead>
				<!-- Rendelésszámonként egy blokk (2026-11-03) -->
				<tbody
					v-for="(g, gi) in groups"
					:key="g.key"
					class="wo-group"
					:class="gi % 2 ? 'wo-group-odd' : 'wo-group-even'"
				>
					<tr class="wo-group-header">
						<td colspan="5">
							<span class="font-weight-bold mr-2">{{ g.nev }}</span>
							<span class="small mr-2" v-if="g.rendelesszam">#{{ g.rendelesszam }}</span>
							<span class="badge badge-primary mr-1">{{ g.items.length }} tétel</span>
							<span class="badge badge-info mr-1" v-if="g.added > 0">{{ g.added }} utólag hozzáadva</span>
							<span class="badge badge-warning mr-1" v-for="w in groupWarnings(g)" :key="w">{{ w }}</span>
						</td>
					</tr>
					<tr
						v-for="v in g.items"
						:key="`list-${v.id}`"
						class="wo-item"
					>
						<td>
							{{ v.nev }}
						</td>
						<td>
							{{ v.regio }}
						</td>
						<td>
							{{ v.kidatum }}
						</td>
						<td>
							{{ v.termek }}
						</td>
						<td>
							{{ v.db }}{{ v.tszam == 2 ? ' x 6' : '' }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="col-12 col-md-8 col-lg-6 alert alert-info text-center" v-else>
			<p class="h4">
				Nincs jóváhagyásra váró webes rendelés
			</p>
		</div>
	</div>
</template>
<script type="text/javascript">
import groupOrders, { groupWarnings } from './groupOrders'

export default {
	props: ['list'],

	methods: {
		groupWarnings
	},

	computed: {
		groups() {
			return groupOrders(this.list)
		}
	}
}
</script>

<style scoped>
.wo-group {
	border-top: 3px solid #adb5bd;
}

.wo-group-header td {
	background: #e9f2fb;
	padding-top: 0.4rem;
	padding-bottom: 0.4rem;
}

.wo-group-odd .wo-group-header td {
	background: #eef6ee;
}

.wo-group-even .wo-item td:first-child {
	box-shadow: inset 4px 0 0 #74a9e0;
}

.wo-group-odd .wo-item td:first-child {
	box-shadow: inset 4px 0 0 #7cc08a;
}
</style>



// WEBPACK FOOTER //
// src/components/webOrders/list.vue